import React, { useEffect, useState, useRef } from "react";
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";

import LogoutPopup from "../components/LogoutPopup";
import NoDataFound from "../components/NoDataFound";
import Searching from "../components/Searching";
import { postData } from "../services/api";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import Tabs from "../components/elements/Tab";
import MonthlyPlan from "../components/TabContent/MonthlyPlan";
import AnnualPlan from "../components/TabContent/AnnualPlan";

import { useTranslation } from "react-i18next";
import Image from "../components/elements/Image";
import { MAIN_LOGO, scheduleButtanLink } from "../constant/Constant";

const BuyPlanV2 = ({ }) => {
  setTitle('Succession Now | Plans');
  const { i18n,t } = useTranslation();
  const navigate = useNavigate();
  const isLogin = localStorage.getItem('accessToken');
  const [loading, setLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [totalDataCount,setTotalDataCount] = useState(0);
  const [enabledLogoutPopup,setenabledLogoutPopup] = useState(false);
  const role =  localStorage.getItem("role");

  const tabs = [
    {
      _id: 'tab1',
      name: 'Monthly',
      component: <MonthlyPlan plans={plans} buttonLink={false}/>
    },
    {
      _id: 'tab2',
      name: 'Annual',
      component: <AnnualPlan plans={plans} buttonLink={false}/>
    },   
  ];

  useEffect(() => {
    async function planList() {
      setLoading(true);
      try {
        const result = await postData('plans/list', {
          sortQuery:{'created_at':1},
          isView : 1
        });
        if (result.data) {
          const rowLen = result?.data?.length;
          setTotalDataCount(result.count);
          setPlans(
            result.data.map((value, key) => {
              if (rowLen === key + 1) {
                return {
                  _id: value?._id,
                  title:value?.name,
                  talk:t('lets_talk'),
                  btnname:"contact us",
                  buttonClasses: '!bg-[#F4F7FA] !text-dark-teal-500 xl:!text-lg lg:h-10 xl:h-14 !px-6',
                  link: {scheduleButtanLink},
                  pricing : value?.pricing,
                  features : value?.features
                }
              } else {
                return {
                  _id: value?._id,
                  title:value?.name,
                  price:value?.price,
                  btnname:t('buy_plan'),
                  buttonClasses: '!bg-dark-teal-500 !text-base xl:!text-lg lg:h-10 xl:h-14 !px-6',
                  link: {scheduleButtanLink},
                  pricing : value?.pricing,
                  features : value?.features
                }
              }                  
            })
          )
          setLoading(false);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
      }
    }
    planList();
  }, []);

  useEffect(()=>{
    if(role && (role === 'master-admin' || role === 'basic-administrator')){
      return navigate("/dashboard-statistics");
    }
  },[role])

  

  return (
    <>
      <section className="relative flex items-center w-full min-h-screen bg-slate-50 py-20 overflow-hidden">
        <div className="w-full max-w-7xl mx-auto">
     <Link to={"/"}>
               <div className="h-14 w-full flex justify-center object-contain mb-5">
                 <Image
                   src={MAIN_LOGO}
                   alt={""}
                   width={"100%"}
                   height={"100%"}
                   classes={"object-contain object-center"}
                 />
               </div>
             </Link>  
          <div className="text-center mb-10 space-y-4">
            <div className="text-3xl font-bold text-dark-teal-500">{t('youare_almost_ready_to_start_planning')}</div>
            <div className="text-3xl font-bold text-dark-teal-500">{t('welcome_to_succession_now')}</div>
          </div>
          <div className="relative">
          {
            (totalDataCount >0)?(
              <Tabs tabs={tabs} navTabClass="max-w-[768px] w-full m-auto" divClass="w-full bg-transparent shadow-none gap-5" buttonClass="w-full rounded-md !text-dark-teal-500 border border-dark-teal-500" tabContentClass="grid grid-cols-1 xs:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-14"/>
            ):(
              loading ? <Searching label={t('searching')} /> : <NoDataFound label={t('no_data_found')} />
            )
          }          
          </div>
            <>
            {
              isLogin ?
              <div className="flex gap-1 item-center justify-center text-slate-400 text-sm pt-4">
                <Button 
                  buttonClasses={'!bg-transparent !text-dark-teal-400 !h-auto !px-0'} 
                  buttonType={''}
                  buttonHasLink={false}
                  buttonLabel={t('logout')} 
                  buttonLabelClasses={'!font-semibold'}
                  functions={() => setenabledLogoutPopup(true)}
                />
              </div>: null
            }
          </>  
        </div>
        {
          enabledLogoutPopup &&
          <LogoutPopup
          isOpen={enabledLogoutPopup}
          setIsOpen={(val) => setenabledLogoutPopup(val)}
          />
        }
      </section>
    </>
  );

}
export default BuyPlanV2;